import React, { useState, useEffect } from 'react';
import './Applications.css';
import OfferLetterTemplates from './OfferLetterTemplates';
import OfferLetter from './OfferLetter';

const ApplicationsPage = ({ user, API_BASE_URL }) => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTemplates, setShowTemplates] = useState(false);
  const [showOfferLetter, setShowOfferLetter] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);

  // Fetch applications from API
  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const token = sessionStorage.getItem('authToken') || sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/applications`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setApplications(data.applications || []);
    } catch (error) {
      console.error('Error fetching applications:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateOffer = (application) => {
    setSelectedApplication(application);
    setShowTemplates(true);
  };

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setShowTemplates(false);
    setShowOfferLetter(true);
  };

  const handleSaveOffer = async () => {
    // Refresh applications after saving offer
    await fetchApplications();
  };

  if (loading) {
    return <div className="loading">Loading applications...</div>;
  }

  return (
    <div className="applications-container">
      <div className="applications-header">
        <h1>📋 Job Applications</h1>
        <div className="applications-stats">
          <span>Total: {applications.length}</span>
          <span>Pending: {applications.filter(app => app.status === 'pending').length}</span>
          <span>Accepted: {applications.filter(app => app.status === 'accepted').length}</span>
        </div>
      </div>

      <div className="applications-table-container">
        <table className="applications-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Position</th>
              <th>Applied Date</th>
              <th>Status</th>
              <th>Offer Letter</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {applications.map(application => (
              <tr key={application._id}>
                <td>
                  <div className="candidate-info">
                    <div className="candidate-name">{application.name}</div>
                    <div className="candidate-email">{application.email}</div>
                  </div>
                </td>
                <td>
                  <div className="position-info">
                    <div className="job-title">{application.jobTitle}</div>
                    <div className="department">{application.department}</div>
                  </div>
                </td>
                <td>
                  {new Date(application.appliedDate).toLocaleDateString()}
                </td>
                <td>
                  <span className={`status-badge status-${application.status}`}>
                    {application.status}
                  </span>
                </td>
                <td>
                  {application.offerLetter ? (
                    <span className="offer-sent">✅ Sent</span>
                  ) : (
                    <span className="offer-pending">⏳ Pending</span>
                  )}
                </td>
                <td>
                  <div className="action-buttons">
                    <button 
                      className="btn-view"
                      onClick={() => {/* View details */}}
                    >
                      👁️ View
                    </button>
                    <button 
                      className="btn-generate"
                      onClick={() => handleGenerateOffer(application)}
                      disabled={application.offerLetter}
                    >
                      {application.offerLetter ? '📄 Edit Offer' : '📝 Generate Offer'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Templates Modal */}
      {showTemplates && (
        <OfferLetterTemplates
          onSelectTemplate={handleTemplateSelect}
          onClose={() => setShowTemplates(false)}
          application={selectedApplication}
        />
      )}

      {/* Offer Letter Editor with Selected Template */}
      {showOfferLetter && selectedTemplate && selectedApplication && (
        <OfferLetter
          application={selectedApplication}
          template={selectedTemplate}
          onClose={() => setShowOfferLetter(false)}
          onSave={handleSaveOffer}
          user={user}
          API_BASE_URL={API_BASE_URL}
        />
      )}
    </div>
  );
};

export default ApplicationsPage;